import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import DocumentMeta from 'react-document-meta';
import { loadStoriesByCategoryRoot } from '../actions';
import { Link } from 'react-router';
import HomeBannerSlider from '../components/homeBanner2/HomeBannerSlider';

class StoryArchive extends Component {
  constructor(props) {
    super(props);
  };

  state = {
    activeCategoryId: 0,
    activeCategoryBoxId: 252,
    activeCategoryName: 'Buy From Women'
  }



  componentWillMount() {
    this.props.loadStoriesByCategoryRoot(this.state.activeCategoryBoxId);

  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }


handleCategoryBoxClick = (id, categoryName) => {
  this.setState({activeCategoryBoxId: id, activeCategoryName: categoryName});
  this.props.loadStoriesByCategoryRoot(id);

  var headerRef = ReactDOM.findDOMNode(this.refs.storyHeaderRef);
  if (headerRef) {
    window.scrollTo(0, headerRef.offsetTop);
  }
}


  render() {
    if ((!this.props.storiesByCategoryRoot.isLoaded) || (!this.props.baseState.isLoaded)) {
      return <span />;
    }

    // Category boxes
    let rootCategories = this.props.baseState.categories;
    let browser = this.props.browser;
    let device;
    let categoryBox;
    let imgPath;


    let storiesByCategoryRoot = this.props.storiesByCategoryRoot;
    //let stories;
    //let story;
    //let categoryStoriesWrapper;
    let storyWrapper;
    let storyLinkUrl;
    //let storyWrapperClass;

    let categoryBoxes = rootCategories.map((category, idx) => {

      if (browser.greaterThan.desktop) {
        device = 'desktop';
      } else {
        device = 'mobile';
      }
      imgPath = 'images/categories/' + device + '/' + category.slug + '.jpg';

      if ( (category.slug != 'buy-from-women-products') && (category.slug != 'buy-from-women-services') ) {
        categoryBox = <div onClick={this.handleCategoryBoxClick.bind(this, category.id, category.name)} style={{backgroundImage: 'url(' + imgPath + ')', backgroundSize: 'cover'}} className="categoryPage-box">

                <div className="categoryPage-boxOverlay"><div className="categoryPage-box-inner vertically-align"><h3 className="categoryPage-categoryName">{category.name}</h3></div></div>

              </div>;
      } else {
        return;
      }
      return categoryBox;

    });

    let categoryBoxesWrapper =  <div className="categoryPage-boxes-wrapper">
        {categoryBoxes}
    </div>;


    let storyThumbs = storiesByCategoryRoot.map((story, idx) => {
      storyLinkUrl = '/story/' + story.id;
      storyWrapper = <div className="storyArchive-storyWrapper">
        <Link to={storyLinkUrl}><div>
          <div className="storyArchive-banner"><img src={story.image_cover} /></div>
          <div className="storyArchive-bodyWrapper">
            <div className="storyArchive-category">{story.category_name}</div>
            <div className="storyArchive-title">{story.title}</div>
            <div className="storyArchive-copy">{story.thumbnail_copy}</div>
            <div className="storyArchive-assetName">Via {story.external_asset_name}</div>
          </div>
        </div></Link>
      </div>;

      return storyWrapper;
    });







    return(
      <div>
        <div className="homeBannerFeaturedOrgs">
          <HomeBannerSlider
            browser = {this.props.browser}
            auth={this.props.auth}
            openSignupFormRequest={this.props.openSignupFormRequest}
          />
        </div>

        <div className="content-wrapper">
          <div className="storyArchive-wrapper">
            <h3 className="section-title home-categoriesTitle">WorldWideWomen Story Archive</h3>
            <div className="section-description">Find stories related to your interests and featuring powerhouse women from all over the globe!</div>


            {categoryBoxesWrapper}
            <h3 ref="storyHeaderRef" className="section-title home-categoriesTitle">Stories from {this.state.activeCategoryName}</h3>
            <div className="storyArchive-storiesWrapper">

              {storyThumbs}
            </div>

          </div>
        </div>
      </div>
    );
  };
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    loadStoriesByCategoryRoot,
    Link,
  }
)(StoryArchive);



// WEBPACK FOOTER //
// ./src/containers/StoryArchive.jsx